import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // ✅ for navigation
import './best.css';

const BookCarousel = () => {
  const wrapperRef = useRef(null);
  const [books, setBooks] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();

  // 🔹 Fetch books from your existing API
useEffect(() => {
  fetch("https://sangitshreeprakashan.com/backend/api/getbook.php")
    .then(res => res.json())
    .then(data => {

      const booksArray = data.data || data;

      const bookList = booksArray.map(book => ({

        id: book.id,
        title: book.title,

        // 🔥 EXACT SAME AS WORKING PAGE
        image: book.image
          ? `https://sangitshreeprakashan.com/backend/${book.image.replace("../", "")}`
          : ""

      }));

      console.log("CAROUSEL IMAGES:", bookList);

      setBooks(bookList);

    })
    .catch(err => console.error("Error fetching books:", err));
}, []);

  // 🔹 Auto-scroll loop
  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper || books.length === 0) return;

    let scrollAmount = 0;
    const scrollStep = 0.8;

    const scroll = () => {
      scrollAmount += scrollStep;
      wrapper.scrollLeft = scrollAmount;

      if (scrollAmount >= wrapper.scrollWidth / 2) {
        scrollAmount = 0;
        wrapper.scrollLeft = 0;
      }

      requestAnimationFrame(scroll);
    };

    const animationId = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(animationId);
  }, [books]);

  // 🔹 Track active item for highlight
  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper || books.length === 0) return;

    const handleScroll = () => {
      const children = Array.from(wrapper.querySelectorAll('.infinite-carousel-item'));
      const middle = wrapper.offsetWidth / 2;

      let closestIndex = 0;
      let closestDistance = Infinity;

      children.forEach((child, index) => {
        const rect = child.getBoundingClientRect();
        const center = rect.left + rect.width / 2;
        const distance = Math.abs(middle - center);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      setActiveIndex(closestIndex);
    };

    wrapper.addEventListener('scroll', handleScroll);
    return () => wrapper.removeEventListener('scroll', handleScroll);
  }, [books]);

  const loopItems = [...books, ...books]; // Infinite loop

  // 🔹 Handle click to navigate to product page
  const handleBookClick = (id) => {
    navigate(`/book/${id}`);
  };

  return (
    <div className="infinite-carousel-wrapper" ref={wrapperRef}>
      <div className="infinite-carousel-track">
        {loopItems.map((item, index) => (
          <div
            key={`${item.id}-${index}`}
            className={`infinite-carousel-item ${index === activeIndex ? 'active' : ''}`}
            onClick={() => handleBookClick(item.id)} // 👈 click to navigate
          >
            <img src={item.image} alt={item.title} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BookCarousel;
